import React, {Component} from 'react';
import { Route, Switch } from 'react-router-dom'
import {Row, Col, Card} from 'reactstrap';
import WpsList from '../../components/Wps/WpsList';
import WpsMain from '../../components/Wps/WpsMain';
import WpsForm from '../../components/Wps/WpsForm';
import WpsView from '../../components/Wps/WpsView';
import WpsAssignProjects from '../../components/Wps/WpsAssignProjects';

export default class Wps extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col md="12">
            <Card>
              <Switch>
                <Route exact path="/wps" component={WpsList}/>
                <Route exact path="/wps/new" component={WpsForm}/>
                <Route exact path="/wps/assign-projects" component={WpsAssignProjects}/>
                <Route exact path="/wps/:id/view" component={WpsView}/>
                <Route exact path="/wps/:id/edit" component={WpsMain}/>
                <Route exact path="/wps/:id" component={WpsView}/>
              </Switch>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Wps/Wps.js